// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "hugcare" + "." + "f4f2aec4" + ".js";
};